"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
exports.ConversionCanvasRunConversionViewSampleButton = ({ onSelect, html, children, isActive }) => {
    return (react_1.default.createElement(react_2.OsmosysButton, { osysName: "SampleButton", size: "sm", osysStyle: "navLink", disabled: isActive, onClick: () => {
            onSelect(html);
        } }, children));
};
//# sourceMappingURL=SampleButton.js.map